import * as React from 'react'
import { Input, Radio, Switch, Typography } from 'antd';
import type { RadioChangeEvent } from 'antd';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import { GroupsObj } from './MainCSoftAccess';
const { Text } = Typography;

interface IProps {
  groupsObj:    GroupsObj
  setGroupsObj: React.Dispatch<React.SetStateAction<GroupsObj>>
}

export default function CColumnsObj(props: IProps){

    return (
      <div>
        <div className="div-text-input">
          <Text className='text-before-input'>Afficher objectifs ?</Text>
          <Radio.Group
            id       = "show_obj"
            value    = {props.groupsObj.show_obj}
            onChange = {(e: RadioChangeEvent) => {
              props.setGroupsObj({
                ...props.groupsObj,
                show_obj: e.target.value
              })
            }}
          >
            <Radio value={true}>Oui</Radio>
            <Radio value={false}>Non</Radio>
          </Radio.Group>
        </div>
        {['1','2','3','4','5'].map((idGroup: string, indexGroup: number) => (
          <div key={indexGroup} className='div-switch'>
            {/* Switch to display or not the fields of the col_obj's informations */}
            <Switch
              id                = {`block_group${idGroup}_displayed`}
              checkedChildren   = {<CheckOutlined />}
              unCheckedChildren = {<CloseOutlined />}
              style             = {{marginRight: '15px'}}
              checked           = {props.groupsObj.groupObjNotEmpty[indexGroup]}
              onChange          = {(checked: boolean) => {
                const updatedGroupObjNotEmpty       = [...props.groupsObj.groupObjNotEmpty]
                updatedGroupObjNotEmpty[indexGroup] = checked
                props.setGroupsObj({
                  ...props.groupsObj,
                  groupObjNotEmpty: updatedGroupObjNotEmpty
                })
              }}
            />
            <b style={{fontSize: '17px'}}>Groupe {idGroup}</b>
            {props.groupsObj.groupObjNotEmpty[indexGroup] && (
              <div>
                <div className="div-text-input">
                  <Text className='text-before-input'>Nom groupe</Text>
                  <Input
                      id       = {`obj_json_groupobj${idGroup}_groupname`}
                      style    = {{borderRadius: '4px'}}
                      value    = {props.groupsObj.obj_json[`groupobj${idGroup}`].groupname}
                      onChange = {(e) => {
                        props.setGroupsObj({
                          ...props.groupsObj,
                          obj_json: {
                            ...props.groupsObj.obj_json,
                            [`groupobj${idGroup}`]: {
                              ...props.groupsObj.obj_json[`groupobj${idGroup}`],
                              groupname: e.target.value
                            }
                          }
                        })
                      }}
                  />
                </div>
                {['1','2','3','4','5','6','7','8','9','10'].map((idChamp: string, indexChamp: number) => (
                  <div key={indexGroup+indexChamp} className="div-text-input">
                    <Text className='text-before-input'>Champ {idChamp}</Text>
                    <Input
                        id       = {`obj_json_groupobj${idGroup}_chp${idChamp}`}
                        style    = {{borderRadius: '4px'}}
                        value    = {props.groupsObj.obj_json[`groupobj${idGroup}`][`chp${idChamp}`]}
                      onChange = {(e) => {
                        props.setGroupsObj({
                          ...props.groupsObj,
                          obj_json: {
                            ...props.groupsObj.obj_json,
                            [`groupobj${idGroup}`]: {
                              ...props.groupsObj.obj_json[`groupobj${idGroup}`],
                              [`chp${idChamp}`]: e.target.value
                            }
                          }
                        })
                      }}
                    />
                  </div>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
    )                   
}
